import bezpieczenstwo from '@components/search/inputs/wyposazenie/bezpieczenstwo'
import komfort from '@components/search/inputs/wyposazenie/komfort'
import audioMultimedia from '@components/search/inputs/wyposazenie/audioMultimedia'
import systemWspomaganiaKierownicy from '@components/search/inputs/wyposazenie/systemWspomaganiaKierownicy'
import osiagiTuning from '@components/search/inputs/wyposazenie/osiagiTuning'
import dlaElektrycznych from '@components/search/inputs/wyposazenie/dlaElektrycznych'

const dodatkoweWyposazenieSamochody = { t: 'Dodatkowe wyposażenie', inputs: [
    bezpieczenstwo,
    komfort,
    audioMultimedia,
    systemWspomaganiaKierownicy,
    osiagiTuning,
    dlaElektrycznych,
]}

export default dodatkoweWyposazenieSamochody